<div class="invoice-view-page" [ngClass]="{'padding-more': showHeader}">
  <!-- <app-loader *ngIf="isSpinning"></app-loader> -->
  <app-table-skeleton *ngIf="isLoading; else showPage"></app-table-skeleton>
  <div class="invoice-view-header" [ngClass]="{'hide': !showHeader, 'show': showHeader}">
    <div class="filters-wrapper">

      <div class="filters">
        <div class="form-group">
          <app-mis-datepicker class="date-position" [singleDateEnabled]="false" [config]="dateMaxConfig"
            (selectedDate)="selectedDate($event)"></app-mis-datepicker>
          <div class="booking-view-invalid-date" *ngIf="displayInvalidDateError">Invalid date range</div>

        </div>

        <div class="invoice-type-filter header-item mr-20"
          *ngIf="bookingTypeConfig && bookingTypeConfig.config.visibility.visible">
          <app-multiselect *ngIf="invoiceFilterConfig" [width]="'180px'" [dropdownListWidth]="'181px'"
            [formControl]="formDetails.get('bookingType')" [options]="bookingTypeConfig.config.values"
            [label]="bookingTypeConfig.config.displayName" (handleApplyFilters)="handleApplyFilters()" [isEmitAllowed]="true">
          </app-multiselect>

        </div>
        <div class="city-filter header-item mr-20" *ngIf="cityConfig && cityConfig.config.visibility.visible">
          <app-multiselect *ngIf="invoiceFilterConfig" [width]="'180px'" [dropdownListWidth]="'181px'"
            [formControl]="formDetails.get('city')" [options]="cityConfig.config.values"
            [label]="cityConfig.config.displayName" (handleApplyFilters)="handleApplyFilters()" [isEmitAllowed]="true">
          </app-multiselect>
        </div>
        <div class="office-filter header-item mr-20" *ngIf="officeConfig && officeConfig.config.visibility.visible">
          <app-multiselect *ngIf="invoiceFilterConfig" [width]="'180px'" [dropdownListWidth]="'181px'"
            [formControl]="formDetails.get('office')" [options]="officeConfig.config.values"
            [label]="officeConfig.config.displayName" (handleApplyFilters)="handleApplyFilters()" [isEmitAllowed]="true">
          </app-multiselect>
        </div>
      </div>
      <div class="download-icons-container">


        <mis-dropdown [data]="reports" height="32px" width="180px" label="Download Reports" dropdownListHeight="60px"
        (onChange)="downloadReport($event)" dropdownListPosition="Left" [searchEnabled]="false" 
      ></mis-dropdown>

        <!-- <button mis-button type="none" size="lg" class="button" (click)="handleDownlodSignInReport()">
          <span mis-input-icon class="btn-icon"><img src="/assets/images/download-report.svg" alt="" /></span>
          Download SignIn Report
        </button>
        <button mis-button type="none" size="lg" class="button" (click)="handleDownloadBookingReport()">
          <span mis-input-icon class="btn-icon"><img src="/assets/images/download-report.svg" alt="" /></span>
          Download Booking Report
        </button> -->
      </div>

    </div>


    <div class="search-filter-container">
      <div>
        <app-dropdown xPosition="left" *ngIf="bulkInvoiceActions.config.visibility.visible">
          <div dropdown-trigger class="trigger">
            <div class="checkbox-header-actions">
              <app-checkbox *ngIf="!showCheckboxHyphen" [checked]="allInvoicesSelected" checkboxValue="all"
                (checkboxSelectedCallback)="handleAllBookingsSelected($event)"></app-checkbox>
              <app-checkbox *ngIf="showCheckboxHyphen" type="hyphen" [checked]="showCheckboxHyphen" checkboxValue="none"
                (checkboxSelectedCallback)="handleAllBookingsSelected($event)">
              </app-checkbox>
              <span class="checkmark-dropdown">
                <img src="../../../assets/images/drop-down-icon-24.svg" alt="">
              </span>
            </div>
          </div>
          <div dropdown-menu *ngIf="!selectedInvoices.length" class="actions-menu">
            <div class="no-bookings-view">Select invoices to see more actions</div>
          </div>
          <div dropdown-menu *ngIf="selectedInvoices.length" class="actions-menu">

            <!-- <button *ngIf="bulkInvoiceActionsObj['Approve Invoice'].visibility.visible" class="menu-item"
              (click)="updateInvoiceStatus('APPROVED')">
              <img src="assets/images/assign_approve.svg" />
              <label>{{bulkInvoiceActionsObj['Approve Invoice'].displayName}}</label>
            </button>

            <button *ngIf="bulkInvoiceActionsObj['Reject Invoice'].visibility.visible" class="menu-item"
              (click)="updateInvoiceStatus('REJECTED')">
              <img src="assets/images/invoice-reject.svg" />
              <label>{{bulkInvoiceActionsObj['Reject Invoice'].displayName}}</label>
            </button> -->

            <button *ngIf="bulkInvoiceActionsObj['Send Invoice'].visibility.visible" class="menu-item"
              (click)="onSendInvoiceClick()">
              <img src="assets/images/invoice_send.svg" />
              <label>{{bulkInvoiceActionsObj['Send Invoice'].displayName}}</label>
            </button>

          </div>
        </app-dropdown>
      </div>
      <div class="search-container">
        <div class="select-input-wrapper input-wrapper requests-search">
          <img src="../../../assets/images/search-icon.svg" alt="search">
          <input class="select-input has-suffix" placeholder="Search" style="border: 0;width: 95%;"
            [(ngModel)]="searchInput" (keyup)="onSearchInputChange($event)" />
        </div>
      </div>

    </div>
  </div>

  <ng-template #showPage>
    <div class="invoice-list-wrapper">
      <div class="invoice-table-wrapper">
        <table class="invoice-details-table">
          <thead class="invoice-table-head" *ngIf="tabularConfigObj">
            <th class="column-heading checkbox-wrapper">
              <div class="check-box">
                <div class="">
                  <!-- <app-checkbox *ngIf="!showCheckboxHyphen" [checked]="allInvoicesSelected" checkboxValue="all"
                    (checkboxSelectedCallback)="handleAllBookingsSelected($event)"></app-checkbox>
                  <app-checkbox *ngIf="showCheckboxHyphen" type="hyphen" [checked]="showCheckboxHyphen"
                    checkboxValue="none" (checkboxSelectedCallback)="handleAllBookingsSelected($event)">
                  </app-checkbox> -->
                </div>
              </div>
            </th>
            <th class="column-heading" *ngIf="tabularConfigObj['Booking ID'].visibility.visible">
              {{tabularConfigObj['Booking ID'].displayName}}</th>
            <th class="column-heading cursor-pointer" *ngIf="tabularConfigObj['Trip Date'].visibility.visible"
              (click)="sortBookings()">
              <div class="trip-date">
                {{tabularConfigObj['Trip Date'].displayName}}
                <div class="sort">
                  <div class="dropdown-up-icon" [ngClass]="{'disabled': !sortAscending}"></div>
                  <div class="dropdown-down-icon" [ngClass]="{'disabled': sortAscending}"></div>
                </div>
              </div>
            </th>
            <th class="column-heading"
              *ngIf="tabularConfigObj['Trip ID'] && tabularConfigObj['Trip ID'].visibility.visible">
              {{tabularConfigObj['Trip ID'].displayName}}</th>
            <th class="column-heading"
              *ngIf="tabularConfigObj['tripStatus'] && tabularConfigObj['tripStatus'].visibility.visible">
              {{tabularConfigObj['tripStatus'].displayName}}</th>
            <th class="column-heading" *ngIf="tabularConfigObj['invoiceNumber'].visibility.visible">
              {{tabularConfigObj['invoiceNumber'].displayName}}</th>
            <th class="column-heading" *ngIf="tabularConfigObj['invoiceApprStatus'].visibility.visible">
              Transport
              Approval</th>
            <th class="column-heading" *ngIf="tabularConfigObj['documentView'].visibility.visible">
              Rider
              Approval</th>
            <th class="column-heading" *ngIf="tabularConfigObj['documentView'].visibility.visible && this.miscellConfig.enableExpenseStatus">
              {{tabularConfigObj['invoiceApprStatus'].displayName}}
            </th>
            <th class="column-heading"
              *ngIf="tabularConfigObj['vendorBillAmount'] && tabularConfigObj['vendorBillAmount'].visibility.visible">
              {{tabularConfigObj['vendorBillAmount'].displayName}}</th>
            <th class="column-heading" *ngIf="tabularConfigObj['bookingAmount'].visibility.visible">
              {{tabularConfigObj['bookingAmount'].displayName}}</th>
            <th class="column-heading"
              *ngIf="tabularConfigObj['paymentStatus'] && tabularConfigObj['paymentStatus'].visibility.visible">
              {{tabularConfigObj['paymentStatus'].displayName}}</th>
              <th class="column-heading" *ngIf="tabularConfigObj['billingType']?.visibility.visible">
                {{tabularConfigObj['billingType'].displayName}}</th>
            <th class="text-center  column-heading">Actions</th>

          </thead>
          <tbody class="table-body">
            <tr class="booking-row" id="table-row"
              *ngFor="let booking of filteredInvoiceDetails  "
              style="border-top: 1px solid black;">

              <td>
                <app-checkbox [checked]="selectedInvoices.length ? isInvoiceChecked({id: booking.bookingId}) : false"
                  [checkboxValue]="booking.bookingId" (checkboxSelectedCallback)="handleBookingsSelected($event)">
                </app-checkbox>
              </td>

              <td class="ellipsis" *ngIf="tabularConfigObj['Booking ID'].visibility.visible" >
                <div class="booking-id-container">
                  <div class="booking-id" (click)="openDrawer(booking)" [title]="booking.bookingId"
                  matTooltip="{{booking.bookingId}}"  matTooltipClass="booking-table-tooltip">
                    {{booking.bookingId}}
                    <!-- {{booking.bookingId.split('').slice(0,2).join('')}}...{{booking.bookingId.split('').slice(booking.bookingId.length-3).join('')}} -->
                  </div>
                  <img *ngIf="booking.guardReq" class="mr-2" [src]="checkIfMarshalAssigned(booking)">
                </div>
              </td>

              <td class="ellipsis" *ngIf="tabularConfigObj['Trip Date'].visibility.visible"
              matTooltip="{{booking.displayDate}}"  matTooltipClass="booking-table-tooltip">
                {{booking.displayDate}}
              </td>
              <!-- | paginate: { itemsPerPage: currentPageSize, currentPage: pageIndexNew, totalItems: totalNoOfRows, id: paginationId } -->
              <td class="ellipsis" 
                *ngIf="tabularConfigObj['Trip ID'] && tabularConfigObj['Trip ID'].visibility.visible"
                matTooltip="{{booking.tripID || '--'}}"  matTooltipClass="booking-table-tooltip">
                {{booking.tripID !== 0 ? booking.tripID : '--'}}</td>
              <td class="ellipsis"
                *ngIf="tabularConfigObj['tripStatus'] && tabularConfigObj['tripStatus'].visibility.visible">
                <ng-container *ngIf="booking.tripStatus !== 'UPCOMING'; else elseBlock" [ngSwitch]="true">
                  <span class="ellipsis in-progress-trip" *ngSwitchCase="booking.tripStatus === 'ON_TRIP'"
                    title="ONGOING">ONGOING</span>
                  <span class="ellipsis completed-trip"
                    *ngSwitchCase="booking.tripStatus === 'COMPLETED' || booking.tripStatus === 'DUTY_COMPLETED' || booking.tripStatus === 'TRIP_COMPLETED'"
                    title="COMPLETED">COMPLETED</span>
                  <span class="ellipsis completed-trip" *ngSwitchCase="booking.tripStatus === 'MANUALLY_COMPLETED'"
                    title="MANUALLY COMPLETED">MANUALLY COMPLETED</span>
                  <span class="ellipsis completed-trip" *ngSwitchCase="booking.tripStatus === 'TRIP_NO_SHOW'"
                    title="Trip No show">No Show</span>
                    <span class="ellipsis completed-trip" *ngSwitchCase="booking.tripStatus === 'TRIP_EXPIRED'"
                     title="Trip No show">EXPIRED</span>
                     <span class="ellipsis completed-trip" *ngSwitchCase="booking.tripStatus === 'NOT_REQUIRED_FOR_NOW'"
                      title="Trip No show">NA</span>
                  <span class="ellipsis" *ngSwitchDefault></span>
                </ng-container>
                <ng-template #elseBlock>
                  <span class="ellipsis upcoming-trip" *ngIf="getTripStatus(booking) === 'UPCOMING'"
                    title="UPCOMING">UPCOMING</span>
                  <span class="ellipsis expired-trip" *ngIf="getTripStatus(booking) === 'TRIP_EXPIRED'"
                    title="EXPIRED">EXPIRED</span>
                  <span class="ellipsis NRFN-trip" *ngIf="getTripStatus(booking) === 'NOT_REQUIRED_FOR_NOW'"
                    title="EXPIRED">NA</span>
                  <div class="ellipsis end-trip" (click)="endTrip(booking)"
                    *ngIf="getTripStatus(booking) === 'MANUALLY END'">End Trip</div>
                </ng-template>
              </td>
              <td class="ellipsis" *ngIf="tabularConfigObj['invoiceNumber'].visibility.visible"
              matTooltip="{{booking.invoiceName || '--'}}"  matTooltipClass="booking-table-tooltip">{{booking.invoiceName}}</td>

              <td *ngIf="tabularConfigObj['invoiceApprStatus'].visibility.visible">
                <span *ngIf="booking.invoiceApprStatus=='APPROVED'" matTooltip="Approved"  matTooltipClass="booking-table-tooltip"><img src="assets/accept_invoice.svg" alt=""></span>
                <span *ngIf="booking.invoiceApprStatus=='REJECTED'" matTooltip="Rejected"  matTooltipClass="booking-table-tooltip"><img src="assets/cancel-circle-filled.svg" alt=""></span>
                <span *ngIf="booking.invoiceApprStatus=='NOT_REQUIRED_FOR_NOW' || booking.invoiceApprStatus=='NOT_NEEDED'" matTooltip="Not Required"  matTooltipClass="booking-table-tooltip">-</span>
                <!-- <app-invoice-status [invoiceApprStatus]="booking.invoiceApprStatus" [statusBy]="'TransportManager'">
                </app-invoice-status> -->
              </td>
              <td *ngIf="tabularConfigObj['invoiceApprStatus'].visibility.visible">
                <span *ngIf="booking.riderInvoiceApprovalStatus=='APPROVED'"  matTooltip="Approved"  matTooltipClass="booking-table-tooltip"><img src="assets/accept_invoice.svg" alt=""></span>
                <span *ngIf="booking.riderInvoiceApprovalStatus=='REJECTED'" matTooltip="Rejected"  matTooltipClass="booking-table-tooltip"><img src="assets/cancel-circle-filled.svg" alt=""></span>
                <span *ngIf="booking.riderInvoiceApprovalStatus=='NOT_REQUIRED_FOR_NOW' || booking.invoiceApprStatus=='NOT_NEEDED'" matTooltip="Not Required"  matTooltipClass="booking-table-tooltip">-</span>
                <!-- <app-invoice-status [invoiceApprStatus]="booking.riderInvoiceApprovalStatus" [statusBy]="'Rider'">
                </app-invoice-status> -->
              </td>
              <td *ngIf="this.miscellConfig.enableExpenseStatus" class=" expenseStatusCount">
                <div class="flex "  matTooltip="Approved"  matTooltipClass="booking-table-tooltip">
                  <img src="assets/approved.svg" alt=""><span>{{booking.expenseStatusCount===null||booking.expenseStatusCount.APPROVED===null?0:booking.expenseStatusCount.APPROVED}}</span>
                </div>
                <div class="flex " matTooltip="Rejected"  matTooltipClass="booking-table-tooltip">
                  <img src="assets/rejected.svg" alt=""><span>{{booking.expenseStatusCount===null||booking.expenseStatusCount.REJECTED===null?0:booking.expenseStatusCount.REJECTED}}</span>
                </div>
                <div class="flex " style="border: none;" matTooltip="Pending"  matTooltipClass="booking-table-tooltip">
                  <img src="assets/pending.svg" alt=""><span>{{booking.expenseStatusCount===null||booking.expenseStatusCount.PENDING===null?0:booking.expenseStatusCount.PENDING}}</span>
                </div>
              </td>
              <td class="ellipsis"
                *ngIf="tabularConfigObj['vendorBillAmount'] && tabularConfigObj['vendorBillAmount'].visibility.visible"
                matTooltip="{{booking.vendorBillAmount || '--'}}"  matTooltipClass="booking-table-tooltip">
                {{booking.vendorBillAmount}}</td>
              <td class="ellipsis" *ngIf="tabularConfigObj['bookingAmount'].visibility.visible"
              matTooltip="{{booking.paymentAmount || '--'}}"  matTooltipClass="booking-table-tooltip">
                {{booking.paymentAmount}}</td>
              <td class="ellipsis"
                *ngIf="tabularConfigObj['paymentStatus'] && tabularConfigObj['paymentStatus'].visibility.visible">
                <span class="ellipsis pending-trip" *ngIf="booking.paymentStatus === 'PENDING'"
                  title="PENDING">PENDING</span>
                <span class="ellipsis completed-trip" *ngIf="booking.paymentStatus === 'PAID'" title="PAID">PAID</span>
                <span class="ellipsis failed-trip" *ngIf="booking.paymentStatus === 'FAILED'">FAILED
                  <img *ngIf="booking.errorDescription != null && booking.errorDescription != ''"
                    class="info-icon-failed" src="assets/info-icon.svg" (mouseenter)="booking.hover = true"
                    (mouseleave)="booking.hover = false" />
                </span>
                <span *ngIf="booking.paymentStatus == 'NOT_REQUIRED_FOR_NOW'">NA</span>
                <div class="failedStatusBlock" *ngIf="booking.hover">
                  <div class="failedStatusDetails">
                    <p class="failed-message">{{booking.errorDescription}}</p>
                  </div>
                </div>
                <span class="ellipsis processing-trip" *ngIf="booking.paymentStatus === 'PROCESSING'" title="PROCESSING">PROCESSING</span>
              </td>
              <td class="ellipsis" *ngIf="tabularConfigObj['billingType']?.visibility.visible"
              [matTooltip]="booking.paymentType ? (booking.paymentType.toLowerCase()==='bill to company'?'PO':'Card'): null"  
              matTooltipClass="booking-table-tooltip"
              >
                {{booking.paymentType ? (booking.paymentType.toLowerCase()==='bill to company'?'PO':'Card'): ''}}
              </td>

              <td class="booking-actions-table-data" *ngIf="invoiceActionsConfigObj && invoiceActionBtnConfigObj">
                <div class="booking-item-actions flex">


                  <app-dropdown xPosition="right" title="Click to access more options"
                    *ngIf="invoiceActionConfig.config.visibility.visible && commonService.workflowConfig">
                    <div dropdown-trigger class="trigger">
                      <app-button type="icon" prefixIconSrc="assets/actions-dropdown.svg"></app-button>
                    </div>
                    <div dropdown-menu class="booking-item-menu">
                      <div (click)="handleEditInvoice(booking)" class="action-menu"
                        *ngIf="invoiceActionBtnConfigObj['Edit Trip Parameters'].visibility.visible"
                        [ngClass]="{'disabled': (!commonService.workflowConfig['enableEditInvoice'] && booking.tripBillingStatus=='CLOSED' && booking.invoiceApprStatus==='APPROVED')}"
                       >
                        <div>
                          <img src="assets/images/invoice_edit.svg" alt="">
                        </div>
                        Edit
                      </div>
                      <div (click)="generateInvoice(booking)"
                        *ngIf="invoiceActionBtnConfigObj['Generate Invoice'].visibility.visible"
                        class="action-menu">
                        <div>
                          <img src="assets/images/invoice-generate-24.svg" alt="">
                        </div>
                        Generate Invoice
                      </div>
                      <div (click)="updateInvoiceStatus('APPROVED',booking)" 
                        [ngClass]="{ 'disabled' : commonService.workflowConfig['invoiceApproval'] && booking.invoiceApprStatus=='PENDING'}"
                                             class="action-menu">
                        <div>
                             <img src="assets/images/assign_approve.svg" alt="" />

                        </div>
                        Approve Invoice
                      </div>
                      <div (click)="updateInvoiceStatus('REJECTED',booking)"
                      [ngClass]="{'disabled' : commonService.workflowConfig['invoiceApproval'] && booking.invoiceApprStatus=='PENDING'}"
                        class="action-menu">
                        <div>
                          <img src="assets/images/invoice-reject.svg" alt="">
                        </div>
                        Reject Invoice
                      </div>
                      <!-- [ngClass]="{'disabled': booking['Generate Invoice-disable'] === true}"  -->
                      <div (click)="handleSendInvoice(booking)"
                        [ngClass]="{'disabled':booking['Send Invoice-disable'] === true}"
                        *ngIf="invoiceActionBtnConfigObj['Send Invoice'].visibility.visible" class="action-menu">
                        <div>
                          <img src="assets/images/invoice-send.svg" alt="">
                        </div>
                        Share Invoice
                      </div>
                      <!-- <div (click)="paymentSuccess($event, booking)" class="action-menu">
                        <div
                          *ngIf="invoiceActionBtnConfigObj['payInvoice'] && invoiceActionBtnConfigObj['payInvoice'].visibility.visible">
                          <div style="margin-top: 55px;">
                            <img src="../../../assets/images/invoice-payment.svg" alt="">
                          </div>
                          <app-payment-button [ngClass]="{'disabled': booking['paymentStatus'] !== 'FAILED'}"
                            [booking]="booking" [fromInvoicePage]="true"
                            (paymentSuccessCallback)="paymentSuccess($event, booking)"
                            (paymentFailedCallback)="paymentFailed($event)">
                          </app-payment-button>
                        </div>
                        Pay
                      </div> -->
                      <div [ngClass]="{'disabled': booking['Download Invoice-disable'] === true}"
                        *ngIf="invoiceActionBtnConfigObj['Download Invoice'].visibility.visible"
                        (click)="downloadInvoice(booking)" class="action-menu">
                        <div>
                          <img src="assets/images/invoice-view-Doc.svg" alt="">
                        </div>
                        View Document
                      </div>
                    </div>
                  </app-dropdown>
                </div>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
      <app-booking-details-popover *ngIf="showBookingDetails && singleBookingDetails"
        [singleBookingDetails]="singleBookingDetails" (closeBookingDetailsCallback)="handleCloseBookingDetails()">
      </app-booking-details-popover>

      <app-popover *ngIf="showErrorDialog" size="send-invoice-error" (closeCallback)="closeModal()">
        <div popover-header class="invoice-error-header">
          <img src="assets/images/error.svg" alt="">
          Invoice Update Error
        </div>
        <div popover-content>
          {{errorMessage}}
        </div>
        <div popover-actions>
          <app-button type="primaryFilled" text="Okay" (clickCallback)="closeModal()">
          </app-button>
        </div>

      </app-popover>
      <app-toast *ngIf="showSuccessToast" [message]="successMessage" (dismissCallback)="toggleToast()">
      </app-toast>
    </div>
  </ng-template>



</div>


<app-send-invoice [bookings]="sendInvoiceBookings" *ngIf="isSendCommVisible" (closeCallback)="hideSendComm()"
  (sendCallback)="sendInvoice($event)"></app-send-invoice>
<app-toast *ngIf="invoiceToastMessage" [message]="invoiceToastMessage" (dismissCallback)="toggleInvoiceActionToast()">
</app-toast>

<app-popover *ngIf="showModal" size="large" (closeCallback)="closeModal()">

  <!-- For approval of invoice -->
  <div popover-header *ngIf="showApproveModal" class="action-header-wrapper">
    <div>
      <img src="../../../assets/images/assign_approve.svg" class="action-dialog-icon" alt="">
    </div>
    <div>
      Approve Booking
    </div>
  </div>
  <div popover-content *ngIf="showApproveModal">
    <ng-container *ngIf="!showApproveReasonBlock else approveReasonBlock">
      <div *ngIf="!eligibleBookings.length">
        Invoices for all booking(s) are in approved or rejected state already.
      </div>
      <div *ngIf="eligibleBookings.length && nonEligibleBookings.length">
        Invoices for Booking(s) {{nonEligibleBookings.join(", ")}} are in approved or rejected state already.
      </div>
      <div *ngIf="eligibleBookings.length" class="mt-20">
        Invoices for Bookings(s) {{eligibleBookings.join(", ")}} are eligible for approval.
      </div>
    </ng-container>
  </div>
  <div popover-actions *ngIf="showApproveModal && !showApproveReasonBlock && eligibleBookings.length">
    <app-button class="mr-10" type="plainText" text="Cancel" (clickCallback)="closeModal()">
    </app-button>

    <app-button class="mr-10" type="primaryFilled" text="Approve" (clickCallback)="showApproveReasonBlock = true">
    </app-button>
  </div>
  <div popover-actions *ngIf="showApproveModal && !showApproveReasonBlock && !eligibleBookings.length">
    <app-button class="mr-10" type="primaryFilled" text="Okay" (clickCallback)="closeModal()">
    </app-button>
  </div>

  <ng-template #approveReasonBlock>
    <div popover-content>
      <div class="mb-10">Please provide your comments <span class="optional"
          *ngIf="approveinvoiceReasonConfig && !approveinvoiceReasonConfig.config.mandatory">(optional)</span></div>
      <textarea name="reason" [(ngModel)]="reasonText" [maxlength]="maxLimit"
        [required]="approveinvoiceReasonConfig && approveinvoiceReasonConfig.config.mandatory" #reasonControl="ngModel"
        rows="3"  class="border-all-E0E0E0 width-full">
      </textarea>
      <div *ngIf="reasonControl.invalid">
        <div class="error-msg" *ngIf="isSubmitReasonClicked && reasonControl.errors.required">This Field is mandatory
        </div>
        <div class="error-msg" *ngIf="reasonControl.errors.maxlength">Limit Exceeded (Max limit - 200 characters)</div>
      </div>
      <div *ngIf="approveReasonForAmountMismatch">
        <span *ngIf="eligibleBookings.length else amountMismatchSingleError">
          *Please provide comments for approving invoices. Vendor invoice amount and system invoice amount are different
          for some of the selected bookings
        </span>
        <ng-template #amountMismatchSingleError>
          *Please provide comments for approving this invoice. Vendor invoice amount and system invoice amount are
          different for this booking
        </ng-template>
      </div>
    </div>
    <div popover-actions class="mt-20 flex flex-end">
      <app-button class="mr-10" type="plainText" text="Cancel" (clickCallback)="closeModal()">
      </app-button>
      <app-button type="primaryFilled" text="Submit" (clickCallback)="submitReason('APPROVED')"></app-button>
    </div>
  </ng-template>

  <!-- For rejecting the invoice-->
  <div popover-header *ngIf="showRejectModal" class="action-header-wrapper">
    <div>
      <img src="../../../assets/images/assign_cancelled.svg" class="action-dialog-icon" alt="">
    </div>
    <div>
      Reject Invoice
    </div>
  </div>

  <div popover-content *ngIf="showRejectModal">
    <ng-container *ngIf="!showRejectReasonBlock else reasonBlock">
      <div *ngIf="!eligibleBookings.length">
        Invoices for all booking(s) are in approved or rejected state already.
      </div>
      <div *ngIf="nonEligibleBookings.length && eligibleBookings.length">
        Invoices for Booking(s) {{nonEligibleBookings.join(", ")}} are in approved or rejected state already.
      </div>
      <div *ngIf="eligibleBookings.length" class="mt-20">
        Invoices for Bookings(s) {{eligibleBookings.join(", ")}} are eligible for rejection.
      </div>
    </ng-container>
  </div>
  <div popover-actions *ngIf="showRejectModal  && !showRejectReasonBlock && eligibleBookings.length">
    <app-button class="mr-10" type="plainText" text="Cancel" (clickCallback)="closeModal()">
    </app-button>
    <app-button class="mr-10" type="primaryFilled" text="Continue" (clickCallback)="showRejectReasonBlock = true">
    </app-button>
  </div>
  <div popover-actions *ngIf="showRejectModal  && !showRejectReasonBlock && !eligibleBookings.length">
    <app-button class="mr-10" type="primaryFilled" text="Okay" (clickCallback)="closeModal()">
    </app-button>
  </div>

  <ng-template #reasonBlock>
    <div popover-content>
      <div class="mb-10">Please provide your comments <span class="optional"
          *ngIf="rejectinvoiceReasonConfig && !rejectinvoiceReasonConfig.config.mandatory">(optional)</span></div>
      <textarea name="reason" [(ngModel)]="reasonText" [maxlength]="maxLimit"
        [required]="rejectinvoiceReasonConfig && rejectinvoiceReasonConfig.config.mandatory" #reasonControl="ngModel"
        rows="3" class="border-all-E0E0E0 width-full">
      </textarea>
      <div *ngIf="reasonControl.invalid">
        <div class="error-msg" *ngIf="isSubmitReasonClicked && reasonControl.errors.required">This Field is mandatory
        </div>
        <div class="error-msg" *ngIf="reasonControl.errors.maxlength">Limit Exceeded (Max limit - 200 characters)</div>
      </div>
    </div>
    <div popover-actions class="mt-20 flex flex-end">
      <app-button class="mr-10" type="plainText" text="Cancel" (clickCallback)="closeModal()">
      </app-button>
      <app-button type="primaryFilled" text="Submit" (clickCallback)="submitReason('REJECTED')"></app-button>
    </div>
  </ng-template>
</app-popover>


<app-cab-track *ngIf="isTrackingVisible" (closeCallback)="toggleTracking()" [booking]="filteredInvoiceDetails[0]">
</app-cab-track>

<app-toast *ngIf="showSuccessMessage" message="Your payment is being processed" (dismissCallback)="dismissToast()">
</app-toast>

<app-pagination *ngIf="totalPages > 0" [totalNoOfRows]="totalNoOfRows" [paginationId]="paginationId"
  [currentPageSize]="currentPageSize" [pageIndex]="pageIndexNew" (changePage)="pageChangedNew($event)"
  (changeTableSize)="showNumberOfRecords($event)" [totalPages]="totalPages" [currentPage]="currentPage+1" [range]="range">
</app-pagination>
